import { render, staticRenderFns } from "./GCashSuccessPageComponent.vue?vue&type=template&id=2c56b65b&scoped=true&"
import script from "./GCashSuccessPageComponent.vue?vue&type=script&lang=js&"
export * from "./GCashSuccessPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./GCashSuccessPageComponent.vue?vue&type=style&index=0&id=2c56b65b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c56b65b",
  null
  
)

export default component.exports